import styled from 'styled-components';

import {Button} from 'components/ui-kit/Button';
import {breakpoint, colors} from 'theme';

export const CreateUserButton = styled(Button)`
    color: ${colors.brandPrimary};
    text-decoration: none;
    width: auto;
    align-self: flex-start;
    margin-top: 10px;
    margin-left: -20px;

    > span {
        padding: 0 20px;
    }

    @media (min-width: ${breakpoint.phone}) {
        margin-top: 0;
        margin-left: 0;
    }
`;

export const HeaderControlContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    gap: 20px;
`;
